"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var domain = 'https://connect.facebook.net';
/* eslint:disable */

var loadScript = function loadScript(locale) {
  if (window.FB) return;

  (function loadFacebookSDK(d, s, id) {
    // fetch customerchat.js
    var fjs = d.getElementsByTagName(s)[0];

    if (d.getElementById(id)) {
      return;
    } //eslint-disable-next-line @typescript-eslint/no-explicit-any


    var js = d.createElement(s);
    js.id = id;
    js.src = "".concat(domain, "/").concat(locale, "/sdk/xfbml.customerchat.js");

    if (fjs) {
      var _fjs$parentNode;

      (_fjs$parentNode = fjs.parentNode) === null || _fjs$parentNode === void 0 ? void 0 : _fjs$parentNode.insertBefore(js, fjs);
    } else {
      d.body.appendChild(js);
    }
  })(window.document, 'script', 'facebook-jssdk');
};
/* eslint:enable */


var load = function load(_ref) {
  var appID = _ref.appID,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
      setState = _ref.setState;
  loadScript(locale);

  window.fbAsyncInit = function () {
    window.FB.init(Object.assign({
      cookie: true,
      xfbml: true,
      version: 'v6.0'
    }, appID ? {
      appId: appID
    } : {}));
  };

  setTimeout(function () {
    return setState('complete');
  }, 2000);
};

var open = function open() {
  if (window.FB) {
    window.FB.CustomerChat.show(true);
  }
};

var close = function close() {
  if (window.FB) {
    window.FB.CustomerChat.hide();
  }
};

var _default = {
  domain: domain,
  load: load,
  open: open,
  close: close
};
exports.default = _default;